import { getRgObjectsOfType as n, RG_TYPE as r } from "@project-rouge/rg-core";
const h = (i) => {
  const l = [], o = n(i, r.Building).reduce((t, e) => t.data.levels.length > e.data.levels.length ? t : e).data.levels;
  for (let t = 0; t < o.length - 1; t++)
    if (o[t].isPodium === !0) {
      const e = o[t].floorWorldBottom, s = o[t + 1].floorWorldBottom;
      l.push(s - e);
    }
  return l;
};
export {
  h as getLevelArrayPodiumHeights
};
//# sourceMappingURL=index14.js.map
